import React from 'react'
import { withIcon } from '../../withIcon'

function YouTubeIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M7 5.625C5.13604 5.625 3.625 7.13604 3.625 9V15C3.625 16.864 5.13604 18.375 7 18.375H17C18.864 18.375 20.375 16.864 20.375 15V9C20.375 7.13604 18.864 5.625 17 5.625H7ZM2.375 9C2.375 6.44568 4.44568 4.375 7 4.375H17C19.5543 4.375 21.625 6.44568 21.625 9V15C21.625 17.5543 19.5543 19.625 17 19.625H7C4.44568 19.625 2.375 17.5543 2.375 15V9ZM9.69206 8.45613C9.88801 8.34518 10.1285 8.34822 10.3216 8.46407L15.3216 11.4641C15.5098 11.577 15.625 11.7805 15.625 12C15.625 12.2195 15.5098 12.423 15.3216 12.5359L10.3216 15.5359C10.1285 15.6518 9.88801 15.6548 9.69206 15.5439C9.49612 15.4329 9.375 15.2252 9.375 15V9C9.375 8.77483 9.49612 8.56707 9.69206 8.45613ZM10.625 10.1039V13.8961L13.7852 12L10.625 10.1039Z" fill={color}/>
    </svg>
  )
}

export default withIcon(YouTubeIcon)
